import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Box,
    Typography,
    Autocomplete,
    TextField,
    Paper
} from '@mui/material';
import StyledTextField from '../../../components/UIComponents/StyledTextField';
import StyledAutocomplete from '../../../components/UIComponents/StyledAutocomplete';
import CustomButton from '../../../components/Buttons';
import theme from "../../../assets/theme"
import { LocalizationProvider, MobileDateTimePicker, MobileTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import dayjs from 'dayjs';
const AddMaintenancePopup = ({
    open,
    onClose,
    onSave,
    formData,
    setFormData,
    issueCategories = [],
    reportedByOptions = [],
    priorityOptions = [],
    roomsOptions = [],
    mode
}) => {


    const [date, setDate] = useState();
    const [hour, setHour] = useState("00");

    const [minute, setMinute] = useState("00");

    useEffect(() => {
        const now = moment();
        setDate(now.format("YYYY-MM-DD"));
        setHour(now.format("HH"));
        setMinute(now.format("mm"));
    }, [open]);



    const isViewMode = mode === "view";
    const isEditMode = mode === "edit";
    const handleChange = (key, value) => {
        console.log("formdata", formData);
        setFormData((prev) => ({
            ...prev,
            [key]: value
        }));
        console.log("formdata", formData);
    };

    const getFormattedDateTime = () => {
        return moment(`${date} ${hour}:${minute}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
    };


    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    backgroundColor: "light.main"
                },
            }}
        >      <DialogTitle>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: -1 }}>
                    <Typography variant='SubTitleBold'>
                        {mode === 'add' ? 'Add Maintenance' : mode === 'edit' ? 'Edit Maintenance' : 'View Maintenance'}
                    </Typography>
                    {(mode === 'edit') && (
                        <Box>
                            <CustomButton
                                size="medium"
                                variant="primaryColor"
                                onClick={() => onSave({ ...formData, resolved_time: getFormattedDateTime(), status: "Canceled" })}
                                sx={{
                                    borderRadius: 2,
                                    border: `2px solid white`,
                                    backgroundColor: theme.palette.red.main,
                                    color: "white",
                                    width: 150,
                                    height: 40,
                                }}
                            >
                                Cancel Request
                            </CustomButton>
                        </Box>
                    )}

                </Box>


            </DialogTitle>
            {(mode === 'edit' || mode === 'view') && (
                <Box display="flex" justifyContent="space-between" mx={3} mb={1}>
                    <Box display="flex">
                        <Typography variant='subHeading'>
                            Request ID :
                        </Typography>
                        <Typography variant='subHeading'>
                            {formData?.id}
                        </Typography>
                    </Box>
                    <Typography variant='subHeading' >
                        Reported : {moment(formData?.date_time).format("YYYY-MM-DD hh:mm A")}
                    </Typography>
                </Box>
            )}


            <Box
                sx={{
                    border: `1px solid ${theme.palette.gray.main}`,
                    borderRadius: '16px',
                    padding: theme.spacing(1),
                    paddingBottom: theme.spacing(1),
                    mx: 2,
                }}>
                <DialogContent>
                    <Box >
                        <Grid container spacing={0.8}>
                            <Grid item size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="bodyText1"
                                    sx={{ color: 'dark.main', mb: 0.5 }}
                                >
                                    Room No.
                                </Typography>
                                {(mode === 'add') && (
                                    <Autocomplete
                                        fullWidth
                                        disabled={isViewMode || isEditMode}
                                        options={roomsOptions}
                                        value={formData.room_no}
                                        onChange={(e, newValue) => handleChange('room_no', newValue)}
                                        getOptionLabel={(option) => option.room_name || ""}
                                        PaperComponent={(props) => (
                                            <Paper
                                                {...props}
                                                sx={{
                                                    '& .MuiAutocomplete-option:hover': {
                                                        backgroundColor: '#E1EFFF!important',
                                                    },
                                                    borderRadius: '8px',
                                                    backgroundColor: 'lightblue.main',
                                                }}
                                            />
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Room No."
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: theme.borderRadius.medium,
                                                        backgroundColor: 'lightgray.main',
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                )}

                                {(mode === 'edit' || mode === 'view') && (
                                    <TextField
                                        type="text"
                                        fullWidth
                                        disabled
                                        value={formData.room_no}    
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                height: '40px',
                                                borderRadius: theme.borderRadius.medium,
                                                backgroundColor: theme.palette.lightgray.main,
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                width: '100%', // Ensure input fills the container
                                            },
                                            '& .MuiInputAdornment-root': {
                                                marginLeft: 0, // Remove any default margin
                                            }
                                        }}

                                    />
                                )}



                            </Grid>

                            <Grid item size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="bodyText1"
                                    sx={{ color: 'dark.main', mb: 0.5 }}
                                >
                                    Issue Category
                                </Typography>
                                <Autocomplete
                                    fullWidth
                                    disabled={isViewMode || isEditMode}
                                    options={issueCategories}
                                    value={formData.issue_category || null}
                                    onChange={(e, newValue) => handleChange('issue_category', newValue)}
                                    getOptionLabel={(option) => option.category_name || ""}
                                    PaperComponent={(props) => (
                                        <Paper
                                            {...props}
                                            sx={{
                                                '& .MuiAutocomplete-option:hover': {
                                                    backgroundColor: '#E1EFFF!important',
                                                },
                                                borderRadius: '8px',
                                                backgroundColor: 'lightred.main',
                                            }}
                                        />
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Issue Category"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: theme.borderRadius.medium,
                                                    backgroundColor: 'lightgray.main',
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item size={{ xs: 6, md: 6 }}>
                                <StyledAutocomplete
                                    label="Reported By"
                                    disabled={isViewMode || isEditMode}
                                    options={reportedByOptions}
                                    value={formData.reported_by}
                                    onChange={(e, newValue) => handleChange('reported_by', newValue)}
                                />
                            </Grid>

                            <Grid item size={{ xs: 6, md: 6 }}>
                                <StyledAutocomplete
                                    label="Priority"
                                    disabled={isViewMode || isEditMode}
                                    options={priorityOptions}
                                    value={formData.priority}
                                    onChange={(e, newValue) => handleChange('priority', newValue)}
                                />
                            </Grid>


                            {(mode === 'add') && (
                                <>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" mb={0.5}>
                                            {mode === 'add' ? 'Issue Date' : 'Resolved Date'}
                                        </Typography>
                                        <TextField
                                            type="date"
                                            fullWidth
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                            inputProps={{
                                                max: moment().format("YYYY-MM-DD"), // 👈 restrict to today or earlier
                                            }}
                                            sx={{
                                                width: '250px', // Ensure full width
                                                '& .MuiOutlinedInput-root': {
                                                    height: '56px',
                                                    borderRadius: theme.borderRadius.medium,
                                                    backgroundColor: theme.palette.lightgray.main,
                                                },
                                                '& .MuiOutlinedInput-input': {
                                                    padding: '16.5px 14px',
                                                    width: '100%', // Ensure input fills the container
                                                },
                                                '& .MuiInputAdornment-root': {
                                                    marginLeft: 0, // Remove any default margin
                                                }
                                            }}

                                        />
                                    </Grid>


                                    <Grid item xs={6} md={6} >
                                        <Typography variant="body2" mb={0.5}>Time</Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <MobileTimePicker
                                                value={dayjs().hour(hour).minute(minute)}
                                                onChange={(newValue) => {
                                                    if (newValue) {
                                                        setHour(String(newValue.hour()).padStart(2, '0'));
                                                        setMinute(String(newValue.minute()).padStart(2, '0'));
                                                    }
                                                }}
                                                ampm={false}
                                                minutesStep={1}
                                                slotProps={{
                                                    textField: {
                                                        variant: 'outlined',
                                                        fullWidth: true,
                                                        InputProps: {
                                                            sx: {
                                                                height: '56px',
                                                                borderRadius: theme.borderRadius.medium,
                                                                backgroundColor: theme.palette.lightgray.main,
                                                                '& fieldset': {
                                                                    borderColor: theme.palette.grey[400], // ✅ normal border
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: theme.palette.primary.main, // ✅ hover border
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: theme.palette.primary.main, // ✅ focus border
                                                                },
                                                            },
                                                        },
                                                        inputProps: {
                                                            style: {
                                                                padding: '16.5px 14px',
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                </>
                            )}


                            <Grid item size={{ xs: 6, md: 12 }}>
                                <StyledTextField
                                    label="Description"
                                    disabled={isViewMode || isEditMode}
                                    multiline
                                    minRows={3}
                                    fullWidth
                                    value={formData.description}
                                    onChange={(e) => handleChange('description', e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
            </Box>

            <Box mb={2} mr={1}>
                <DialogActions sx={{ pb: 2 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                        {/* Left Side - Resolved On */}

                        {formData?.status === "Completed" && (
                            <Box display="flex" alignItems="center" paddingLeft={2} gap={1}>
                                <Typography variant="subHeading">Resolved On:</Typography>

                                <Typography variant="subHeading">{moment(formData?.resolved_time).format("YYYY-MM-DD hh:mm A")}</Typography>
                            </Box>
                        )}

                        {mode === 'edit' && (
                            <Box mt={1} ml={1} width="100%">
                                <Box
                                    sx={{
                                        border: `1px solid ${theme.palette.gray.main}`,
                                        borderRadius: '16px',
                                        backgroundColor: theme.palette.lightgray.main,
                                        padding: 2,
                                        mb: 3,
                                    }}
                                >
                                    {/* <Typography variant="subHeading" mb={2}>
                                        Resolved Information
                                    </Typography> */}

                                    <Grid container spacing={2} justifyContent="center" alignItems="center" width="auto">
                                        <Grid item xs={12} md={6}>
                                            <Typography variant="body2" mb={0.5}>Resolved Date</Typography>
                                            <TextField
                                                type="date"
                                                fullWidth
                                                value={date}
                                                onChange={(e) => setDate(e.target.value)}
                                                sx={{
                                                    width: '200px',
                                                    '& .MuiOutlinedInput-root': {
                                                        height: '56px',
                                                        borderRadius: theme.borderRadius.medium,
                                                        backgroundColor: 'white',
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '16.5px 14px',
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6} ml={1}>
                                            <Typography variant="body2" mb={0.5}>Resolved Time</Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <MobileTimePicker
                                                    value={dayjs().hour(hour).minute(minute)}
                                                    onChange={(newValue) => {
                                                        if (newValue) {
                                                            setHour(String(newValue.hour()).padStart(2, '0'));
                                                            setMinute(String(newValue.minute()).padStart(2, '0'));
                                                        }
                                                    }}
                                                    ampm={false}
                                                    minutesStep={1}
                                                    slotProps={{
                                                        textField: {
                                                            variant: 'outlined',
                                                            fullWidth: true,
                                                            InputProps: {
                                                                sx: {
                                                                    height: '56px',
                                                                    borderRadius: theme.borderRadius.medium,
                                                                    backgroundColor: 'white',
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.grey[400],
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                },
                                                            },
                                                            inputProps: {
                                                                style: {
                                                                    padding: '16.5px 14px',
                                                                },
                                                            },
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    </Grid>

                                    <Box display="flex" justifyContent="flex-end" mt={4} pr={4}>
                                        {/* <CustomButton
                                            size="medium"
                                            variant="primaryColor"
                                            onClick={onClose}
                                            sx={{
                                                borderRadius: 2,
                                                border: `2px solid ${theme.palette.primary.main}`,
                                                backgroundColor: "light.main",
                                                color: "primary.main",
                                                width: 120,
                                                height: 36,
                                            }}
                                        >
                                            Cancel
                                        </CustomButton> */}

                                        <CustomButton
                                            onClick={() =>
                                                onSave({
                                                    ...formData,
                                                    resolved_time: getFormattedDateTime(),
                                                    status: "Completed",
                                                })
                                            }
                                            size="medium"
                                            variant="primaryColor"
                                            sx={{
                                                borderRadius: 2,
                                                border: `1px solid gray.main`,
                                                backgroundColor: "primary.main",
                                                color: "light.primary",
                                                width: 160,
                                                height: 40,
                                            }}
                                        >
                                            Mark as Resolved
                                        </CustomButton>
                                    </Box>
                                </Box>


                            </Box>
                        )}


                        <Box display="flex" gap={1} ml="auto" mt={2} mb={-1}>
                            {mode === 'add' && (
                                <>
                                    <CustomButton
                                        size="medium"
                                        variant="primaryColor"
                                        onClick={onClose}
                                        sx={{
                                            borderRadius: 2,
                                            border: `2px solid ${theme.palette.primary.main}`,
                                            backgroundColor: "light.main",
                                            color: "primary.main",
                                            width: 120,
                                            height: 36,
                                        }}
                                    >
                                        Cancel
                                    </CustomButton>
                                    <CustomButton
                                        onClick={() => onSave({ ...formData, reported_time: getFormattedDateTime(), status: "Pending" })}
                                        size="medium"
                                        variant="primaryColor"
                                        sx={{
                                            borderRadius: 2,
                                            border: `1px solid gray.main`,
                                            backgroundColor: "primary.main",
                                            color: "light.primary",
                                            width: 120,
                                            height: 36,
                                        }}
                                    >
                                        Save
                                    </CustomButton>
                                </>
                            )}



                            {isViewMode && (
                                // <Box display="flex" gap={1}>
                                <>
                                    <CustomButton
                                        size="medium"
                                        variant="primaryColor"
                                        onClick={onClose}
                                        sx={{
                                            borderRadius: 2,
                                            border: `2px solid ${theme.palette.primary.main}`,
                                            backgroundColor: "light.main",
                                            color: "primary.main",
                                            width: 120,
                                            height: 36,
                                        }}
                                    >
                                        Cancel
                                    </CustomButton>
                                </>
                                // </Box>
                            )}
                        </Box>
                        {/* Right Side - Buttons */}




                    </Box>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default AddMaintenancePopup;
